<template>
    <div class="activity-indicator-chase">
        <div class="activity-indicator-chase-dot" />
        <div class="activity-indicator-chase-dot" />
        <div class="activity-indicator-chase-dot" />
        <div class="activity-indicator-chase-dot" />
        <div class="activity-indicator-chase-dot" />
        <div class="activity-indicator-chase-dot" />
    </div>
</template>